import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ILanguageModelsService = ( createDecorator('ILanguageModelsService'));
export { ILanguageModelsService };
